import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import {
  FiSearch,
  FiCheckCircle,
  FiXCircle,
  FiRefreshCw,
  FiDownload,
  FiEye,
} from "react-icons/fi";
import Swal from "sweetalert2";
import ReactPaginate from "react-paginate";

export default function BankVerificationQueue() {
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("failed");
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // Static data - replace with API calls later
  const [verificationCases] = useState([
    {
      id: 1,
      userId: "USR-001",
      userName: "Rajesh Kumar",
      bankName: "HDFC Bank",
      accountNumber: "****1234",
      ifscCode: "HDFC0001234",
      failureReason: "IFSC code mismatch",
      submittedDate: "2024-01-20",
      status: "Failed",
    },
    {
      id: 2,
      userId: "USR-002",
      userName: "Priya Sharma",
      bankName: "ICICI Bank",
      accountNumber: "****5678",
      ifscCode: "ICIC0005678",
      failureReason: "Account name mismatch",
      submittedDate: "2024-01-19",
      status: "Failed",
    },
    {
      id: 3,
      userId: "USR-003",
      userName: "Amit Patel",
      bankName: "SBI",
      accountNumber: "****9012",
      ifscCode: "SBIN0009012",
      failureReason: "Verification pending",
      submittedDate: "2024-01-18",
      status: "Pending",
    },
  ]);

  const handleApprove = (caseId) => {
    Swal.fire({
      title: "Approve Bank Verification?",
      text: "Are you sure you want to approve this bank account?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Approve",
      confirmButtonColor: "#5000C0",
      cancelButtonColor: "#3085d6",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("Approved!", "Bank verification has been approved.", "success");
      }
    });
  };

  const handleMarkFailed = (caseId) => {
    Swal.fire({
      title: "Mark as Failed",
      html: `
        <input id="failureReason" class="swal2-input" placeholder="Enter failure reason..." required>
      `,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Mark Failed",
      confirmButtonColor: "#ef4444",
      cancelButtonColor: "#3085d6",
      preConfirm: () => {
        const reason = document.getElementById("failureReason").value;
        if (!reason) {
          Swal.showValidationMessage("Please enter a failure reason");
        }
        return reason;
      },
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("Marked as Failed", `Reason: ${result.value}`, "info");
      }
    });
  };

  const handleReverify = (caseId) => {
    Swal.fire({
      title: "Re-verify Bank Account",
      text: "This will trigger a new verification process.",
      icon: "info",
      showCancelButton: true,
      confirmButtonText: "Re-verify",
      confirmButtonColor: "#5000C0",
      cancelButtonColor: "#3085d6",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("Re-verification Started!", "Bank account verification process initiated.", "success");
      }
    });
  };

  const filteredCases = verificationCases.filter((verificationCase) => {
    const matchesSearch =
      verificationCase.userName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      verificationCase.bankName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      verificationCase.userId.includes(searchTerm);
    const matchesStatus = statusFilter === "all" || verificationCase.status === statusFilter;
    return matchesSearch && matchesStatus;
  });

  const indexOfLastItem = (currentPage + 1) * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredCases.slice(indexOfFirstItem, indexOfLastItem);
  const pageCount = Math.ceil(filteredCases.length / itemsPerPage);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(parseInt(e.target.value));
    setCurrentPage(0);
  };

  return (
    <>
      <div className="main-content">
        <div className="page-wrapper page-settings">
          <div className="content">
            {/* Breadcrumb and Header Section with Card Shadow */}
            <div
              className="mb-4"
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
                 <div className="content-page-header content-page-headersplit">
                <h5>Bank Verification Queue</h5>
              </div>
              <nav
                aria-label="breadcrumb"
                style={{ "--bs-breadcrumb-divider": "none", marginBottom: "15px" }}
              >
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <NavLink to="/dashboard">Dashboard</NavLink> /
                  </li>
                  <li className="breadcrumb-item">
                    <NavLink to="/admin/users/directory">Users</NavLink> /
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Bank Verification Queue
                  </li>
                </ol>
              </nav>
           
            </div>

            {/* Filters Section with Card Shadow */}
            <div
              className="mb-4"
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
              <div className="d-flex justify-content-between align-items-center flex-wrap">
                {/* Filters */}
                <div className="row g-2 flex-grow-1">
                  {/* Search */}
                  <div className="col-12 col-md-6">
                    <div className="position-relative">
                      <FiSearch
                        style={{
                          position: "absolute",
                          left: "12px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          color: "#64748b",
                          zIndex: 1,
                        }}
                      />
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search by name, bank, or user ID..."
                        value={searchTerm}
                        onChange={(e) => {
                          setSearchTerm(e.target.value);
                          setCurrentPage(0);
                        }}
                        style={{ paddingLeft: "40px" }}
                      />
                    </div>
                  </div>

                  {/* Status Filter */}
                  <div className="col-12 col-md-3">
                    <select
                      className="form-control"
                      value={statusFilter}
                      onChange={(e) => {
                        setStatusFilter(e.target.value);
                        setCurrentPage(0);
                      }}
                    >
                      <option value="all">All Status</option>
                      <option value="Failed">Failed</option>
                      <option value="Pending">Pending</option>
                      <option value="Verified">Verified</option>
                    </select>
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="ms-md-3 mt-3 mt-md-0">
                  <button className="btn btn-primary">
                    {/* <FiDownload className="me-2" /> */}
                    Export
                  </button>
                </div>
              </div>
            </div>

            {/* Table Section with Card Shadow */}
            <div
              className="mb-4"
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
              <div className="row">
                <div className="col-12">
                  <div className="table-responsive">
                    <table className="table datatable">
                      <thead>
                        <tr>
                          <th>User ID</th>
                          <th>Name</th>
                          <th>Bank Name</th>
                          <th>Account Number</th>
                          <th>IFSC Code</th>
                          <th>Failure Reason</th>
                          <th>Status</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentItems.length === 0 ? (
                          <tr>
                            <td colSpan="8">No data available</td>
                          </tr>
                        ) : (
                          currentItems.map((verificationCase) => (
                            <tr key={verificationCase.id}>
                              <td style={{ fontWeight: "500" }}>{verificationCase.userId}</td>
                              <td style={{ fontWeight: "500" }}>{verificationCase.userName}</td>
                              <td>{verificationCase.bankName}</td>
                              <td>{verificationCase.accountNumber}</td>
                              <td>{verificationCase.ifscCode}</td>
                              <td>{verificationCase.failureReason}</td>
                              <td>
                                <span className={verificationCase.status === "Verified" ? "badge-active" : verificationCase.status === "Failed" ? "badge-pending" : "badge-pending"}>
                                  {verificationCase.status}
                                </span>
                              </td>
                              <td>
                                <div className="table-actions d-flex justify-content-center">
                                  <div
                                    className="delete-table me-2"
                                    title="View Details"
                                    style={{ cursor: "pointer" }}
                                  >
                                    <i className="fas fa-eye"></i>
                                  </div>
                                  <div
                                    className="delete-table me-2"
                                    onClick={() => handleApprove(verificationCase.id)}
                                    title="Approve"
                                    style={{ cursor: "pointer", color: "#10b981" }}
                                  >
                                    <i className="fas fa-check-circle"></i>
                                  </div>
                                  <div
                                    className="delete-table me-2"
                                    onClick={() => handleMarkFailed(verificationCase.id)}
                                    title="Mark as Failed"
                                    style={{ cursor: "pointer", color: "#ef4444" }}
                                  >
                                    <i className="fas fa-times-circle"></i>
                                  </div>
                                  <div
                                    className="delete-table"
                                    onClick={() => handleReverify(verificationCase.id)}
                                    title="Re-verify"
                                    style={{ cursor: "pointer" }}
                                  >
                                    <i className="fas fa-redo"></i>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              {/* Pagination */}
              {pageCount > 1 && (
                <nav className="mt-4 pagination justify-content-end gap-2">
                  <select
                    className="form-select"
                    style={{ width: "70px", padding: "0 13px" }}
                    value={itemsPerPage}
                    onChange={handleItemsPerPageChange}
                  >
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="30">30</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                  <ReactPaginate
                    className="pagination justify-content-center"
                    previousLabel={"Previous"}
                    nextLabel={"Next"}
                    pageCount={pageCount}
                    pageClassName={"page-link"}
                    onPageChange={handlePageClick}
                    containerClassName={"pagination"}
                    previousLinkClassName={"page-link"}
                    nextLinkClassName={"page-link"}
                    disabledClassName={"disabled"}
                    activeClassName={"active"}
                  />
                </nav>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
